import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Button, Paper } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
export const NoAccess = ({ onRetry }) => {
    return (_jsx(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: 'background.default',
            padding: 3,
        }, children: _jsxs(Paper, { elevation: 3, sx: {
                padding: 4,
                textAlign: 'center',
                maxWidth: 400,
                borderRadius: 2,
            }, children: [_jsx(LockIcon, { sx: {
                        fontSize: 64,
                        color: 'error.main',
                        marginBottom: 2,
                    } }), _jsx(Typography, { variant: "h4", gutterBottom: true, color: "error", children: "Access Denied" }), _jsx(Typography, { variant: "body1", color: "text.secondary", paragraph: true, children: "You don't have access to this application. Please contact your administrator to request access or verify your account permissions." }), _jsx(Typography, { variant: "body2", color: "text.secondary", paragraph: true, children: "If you believe this is an error, please try signing in again with the correct account." }), onRetry && (_jsx(Button, { variant: "contained", onClick: onRetry, sx: { marginTop: 2 }, children: "Try Again" }))] }) }));
};
